import messageData from './validate-message.json';

export function getValidateMessage() {
	return messageData;
}
